import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { MdSort } from 'react-icons/md';
import { Button } from 'react-bootstrap';
import { Shapes } from '../../models/entities';

class SortableHeader extends PureComponent {
  constructor(props) {
    super(props);
    this.onClickHeader = this.onClickHeader.bind(this);
  }

  onClickHeader() {
    const { onClick, fieldName, sorting } = this.props;
    if (sorting.sortBy === fieldName) {
      onClick({ sortBy: fieldName, sortDesc: !sorting.sortDesc });
    } else {
      onClick({ sortBy: fieldName, sortDesc: false });
    }
  }

  render() {
    const {
      children, sorting, fieldName, disabled,
    } = this.props;

    const iconStyle = { marginLeft: '0.5rem' };
    if (!(sorting.sortBy === fieldName && sorting.sortDesc)) {
      iconStyle.transform = 'scaleY(-1)';
    }

    const selected = fieldName === sorting.sortBy;

    return (
      <th>
        <Button
          variant="link"
          onClick={this.onClickHeader}
          disabled={disabled}
        >
          {children}
          {selected ? (<MdSort size={20} style={iconStyle} />) : null}
        </Button>
      </th>
    );
  }
}

SortableHeader.propTypes = {
  fieldName: PropTypes.string.isRequired,
  sorting: Shapes.SORTING.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

SortableHeader.defaultProps = {
  children: undefined,
  disabled: false,
};

export default SortableHeader;
